import * as React from 'react';

import type {ExternalServiceType} from 'nutshell-graphql-types';
import type {ExternalMeetingFragment} from 'nutshell-graphql-types';

import {MeetingsTable} from './meetings-table';
import {LoggedTableEmptyState} from './tables/logged-table-empty-state';
import type {ExternalServiceTypeFrontend} from './tables/types';

type Props = {
    meetings: ExternalMeetingFragment[];
    fetchNextPage: () => Promise<any>;
    fetchPreviousPage: () => Promise<any>;
    totalCount: number;
    pageSize: number;
    isLoading: boolean;
    serviceType: ExternalServiceType | ExternalServiceTypeFrontend;
    isPerformingInitialSync: boolean;
    firstEnabledIntegrationType: ExternalServiceType | null | undefined;
    hasUnloggedMeetings: boolean;
    shouldShowSummaryColumn: boolean;
};

export function LoggedMeetingsTable(props: Props) {
    return (
        <MeetingsTable
            meetings={props.meetings}
            fetchNextPage={props.fetchNextPage}
            fetchPreviousPage={props.fetchPreviousPage}
            totalCount={props.totalCount}
            pageSize={props.pageSize}
            isLoading={props.isLoading}
            serviceType={props.serviceType}
            shouldShowSummaryColumn={props.shouldShowSummaryColumn}
            emptyState={
                <LoggedTableEmptyState
                    totalCount={props.totalCount}
                    isPerformingInitialSync={props.isPerformingInitialSync}
                    firstEnabledIntegrationType={props.firstEnabledIntegrationType}
                    serviceType={props.serviceType}
                    hasUnloggedMeetings={props.hasUnloggedMeetings}
                />
            }
        />
    );
}
